import { toSpeedEvent } from './APITransformers';

import type { RoadSpeedEvent, UUID, VehicleSpeedEvent } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';

export class SpeedingRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getRoadEvents = (start: number, end: number, driverIds?: UUID[], vehicleIds?: UUID[], size?: number): Promise<RoadSpeedEvent[]> => {
    const tz = TimeZone.getEncodedTimeZone();
    const driverIdsParameter = (driverIds && `&driver_ids=${driverIds.join(',')}`) || '';
    const vehicleIdsParameter = (vehicleIds && `&vehicle_ids=${vehicleIds.join(',')}`) || '';
    const sizeParameter = (size && `&size=${size}`) || '';
    const requestData = {
      endpoint: `speed/road-events?begin=${start}&end=${end}&tz=${tz}${driverIdsParameter}${vehicleIdsParameter}${sizeParameter}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.map(toSpeedEvent('road')));
  };

  public getVehicleEvents = (start: number, end: number, driverIds?: UUID[], vehicleIds?: UUID[], size?: number): Promise<VehicleSpeedEvent[]> => {
    const tz = TimeZone.getEncodedTimeZone();
    const driverIdsParameter = (driverIds && `&driver_ids=${driverIds.join(',')}`) || '';
    const vehicleIdsParameter = (vehicleIds && `&vehicle_ids=${vehicleIds.join(',')}`) || '';
    const sizeParameter = (size && `&size=${size}`) || '';
    const requestData = {
      endpoint: `speed/vehicle-events?begin=${start}&end=${end}&tz=${tz}${driverIdsParameter}${vehicleIdsParameter}${sizeParameter}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.map(toSpeedEvent('vehicle')));
  };
}

export default SpeedingRequester;
